import {xCore} from '../core';
import {NSServerCallsFetch} from './servercalls_fetch';

//console.log("runing servercalls.js");


export let NSServerCalls = {}
NSServerCalls.init = function()
{

    this.f_make_ajax_call_by_fetch =          function () { return NSServerCalls_Private.f_make_ajax_call_by_fetch.apply( NSServerCalls_Private, arguments ); };
    this.f_get_tree_node_data =               function () { return NSServerCalls_Private.f_get_tree_node_data.apply( NSServerCalls_Private, arguments ); };
    this.f_data_model_info_get_table =        function () { return NSServerCalls_Private.f_data_model_info_get_table.apply( NSServerCalls_Private, arguments ); };
    this.f_get_record_external_join_info =    function () { return NSServerCalls_Private.f_get_record_external_join_info.apply( NSServerCalls_Private, arguments ); };
    this.f_get_page_labels =                  function () { return NSServerCalls_Private.f_get_page_labels.apply( NSServerCalls_Private, arguments ); };
    this.f_edit_obj_upsert =                  function () { return NSServerCalls_Private.f_edit_obj_upsert.apply( NSServerCalls_Private, arguments ); };
    this.f_edit_obj_delete =                  function () { return NSServerCalls_Private.f_edit_obj_delete.apply( NSServerCalls_Private, arguments ); };
    this.f_get_user_permissions =             function () { return NSServerCalls_Private.f_get_user_permissions.apply( NSServerCalls_Private, arguments ); };
    
    /**
     * 
     * @returns promise
     */
    this.f_advanced_search =            function () { return NSServerCalls_Private.f_advanced_search.apply( NSServerCalls_Private, arguments ); };

    /**
     * 
     * @returns promise
     */
    this.f_text_search =                function () { return NSServerCalls_Private.f_text_search.apply( NSServerCalls_Private, arguments ); };

    /**
     * 
     * @returns promise
     */
    this.f_print_get_capabilities =     function () { return NSServerCalls_Private.f_print_get_capabilities.apply( NSServerCalls_Private, arguments ); };

    /**
     * 
     * @returns promise
     */
     this.f_print =                      function () { return NSServerCalls_Private.f_print.apply( NSServerCalls_Private, arguments ); };

     /**
      * 
      * @returns promise
      */
     this.f_print_pdm =                      function () { return NSServerCalls_Private.f_print_pdm.apply( NSServerCalls_Private, arguments ); };
     
    /**
     * 
     * @returns promise
     */
    this.f_get_pdm_analysis =           function () { return NSServerCalls_Private.f_get_pdm_analysis.apply( NSServerCalls_Private, arguments ); };
    
    /**
     * 
     * @returns promise
     */
     this.f_get_pdm_intersected_tables =  function () { return NSServerCalls_Private.f_get_pdm_intersected_tables.apply( NSServerCalls_Private, arguments ); };

    /**
     * 
     * @returns promise
     */
    this.f_geospatial_context_search =            function () { return NSServerCalls_Private.f_geospatial_context_search.apply( NSServerCalls_Private, arguments ); };
  
    
  
  
  /*
  geoserver.wfs, methods:
                    get_feature
                    get_feature_by_id_list
  */
  this.geoserver = NSServerCalls_Private.geoserver;


  window.NSServerCalls_ = NSServerCalls;
  window.NSServerCalls_Private_ = NSServerCalls_Private;
	
}


let NSServerCalls_Private = 
{

    private_objs:
    {
        s_CONST_GEOSERVER_WORKSPACE: "GeoCascais"
    },


    /**
     * Makes AJAX calls and handles many defaults 
     * @param {object}  o_in            - The ajax resquest configurations
     *  o_in:
     * {
     *      url,
     *      ... // params that may be present in fetch method options
     * }
     * @returns A promise for the fetch call.
     */
     f_make_ajax_call_by_fetch: function(o_in) 
     {
        let o_promise = NSServerCallsFetch.f_make_ajax_call_by_fetch(o_in);
        return o_promise;
     },


    f_get_tree_node_data: function(callback)
    {

        let url = xCore.application.endpoints.service_hub_base_url + '/rest/all/auth/get_user_layers';


        NSServerCalls.f_make_ajax_call_by_fetch({"url": url}).then(function(response)
        {
            let o_promise_resp_read = response.json();
            o_promise_resp_read.then( function(o_resp_json)
            {
                callback( o_resp_json );
            });

            
        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
        });
        
    }, 

    /**
        @param o_data_in
        @example
        o_data_in:
        {
            "table_urn",    // ex: "urnXYZtableXYZteste_01XYZtabela_01",
            "language",     //optional default: "pt", 
            "full_info",    //optional default: "false", 
        }
    */
    f_data_model_info_get_table: function(o_data_in, callback)
    {

        let url = xCore.application.endpoints.service_hub_base_url + '/rest/data_model_info/get_table';

        let o_default_data = {
            "language": "pt", 
            "full_info": false
        }

        //->(target, source)
        let o_data = ( o_data_in!=null )? Object.assign( o_default_data, o_data_in ): o_default_data;


        NSServerCalls.f_make_ajax_call_by_fetch(
            {
                "url": url,
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(o_data),
            }
            
            ).then(function(response)
        {
            let o_promise_resp_read = response.json();
            o_promise_resp_read.then( function(o_resp_json)
            {
                callback( o_resp_json );
            });

            
        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
        });
        
    },

     /**
        @param o_data_in
        @example
        o_data_in:
        {
            s_record_urn    //ex: urn__SEP__field__SEP__teste_01__SEP__tabela_01__SEP__1
        }
    */
    f_get_record_external_join_info: function(o_data_in, callback)
    {
        let s_CONST_GEOSERVER_WORKSPACE = NSServerCalls_Private.private_objs.s_CONST_GEOSERVER_WORKSPACE;

        //http://127.0.0.1/servicehub/geoserver/ogc/GeoCascais/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=GeoCascais%3Aget_record_external_join_info&maxFeatures=50&outputFormat=application%2Fjson&viewparams=s_record_urn:urn__SEP__field__SEP__teste_01__SEP__tabela_01__SEP__1

        let url = xCore.application.endpoints.service_hub_base_url 
            + '/geoserver/ogc/'+s_CONST_GEOSERVER_WORKSPACE+'/ows?service=WFS&version=1.0.0&request=GetFeature&typeName='+s_CONST_GEOSERVER_WORKSPACE+':get_record_external_join_info&maxFeatures=50&outputFormat=application/json'
            + '&viewparams=s_record_urn:' + o_data_in.s_record_urn;


        NSServerCalls.f_make_ajax_call_by_fetch(
            {
                "url": url,
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
                //, body: JSON.stringify(o_data),
            }
            
            ).then(function(response)
        {
            let o_promise_resp_read = response.json();
            o_promise_resp_read.then( function(o_resp_json)
            {
                callback( o_resp_json );
            });

            
        })
        .catch(err => { 
            console.log(err);
            console.error( "error" + err.status + err.statusText );
        });

    },

    /**
        @param o_data_in
        @example
        o_data_in:
        {
            s_language_internal_name:    //ex: "pt" || "en", default 'pt'
        }
    */
    f_get_page_labels: function(o_data_in, callback)
    {
        let s_CONST_GEOSERVER_WORKSPACE = NSServerCalls_Private.private_objs.s_CONST_GEOSERVER_WORKSPACE;

        //http://127.0.0.1/servicehub/geoserver/ogc/GeoCascais/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=GeoCascais%3Aget_record_external_join_info&maxFeatures=50&outputFormat=application%2Fjson&viewparams=s_record_urn:urn__SEP__field__SEP__teste_01__SEP__tabela_01__SEP__1

        let s_language_internal_name = o_data_in.s_language_internal_name? o_data_in.s_language_internal_name : 'pt';
        let url = xCore.application.endpoints.service_hub_base_url 
            + '/geoserver/ogc/'+s_CONST_GEOSERVER_WORKSPACE+'/ows?service=WFS&version=1.0.0&request=GetFeature&typeName='+s_CONST_GEOSERVER_WORKSPACE+':get_page_labels_by_language&maxFeatures=1000&outputFormat=application/json'
            + '&viewparams=s_language_internal_name:' + s_language_internal_name;


        NSServerCalls.f_make_ajax_call_by_fetch(
            {
                "url": url,
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
                //, body: JSON.stringify(o_data),
            }
            
            ).then(function(response)
        {
            let o_promise_resp_read = response.json();
            o_promise_resp_read.then( function(o_resp_json)
            {
                callback( o_resp_json );
            });

            
        })
        .catch(err => { 
            console.log(err);
            console.error( "error" + err.status + err.statusText );
        });

    },

    /**
        @example
        //INSERT:
        o_data_in:
        {
            "table_urn": "urnXYZtableXYZmunicipioXYZarvores",
            "input_params": [
                {"name": "id", "value": null}, 
                {"name": "geometria", "value": "POINT(-9.43874639170304 38.73721155594517)"}, 
                {"name": "numero_registo", "value": "1001002"}, 
                {"name": "codigo_rua", "value": "20001002"}, 
                {"name": "rua", "value": "Rua de Teste 1002"}
                ]    
        }

        UPDATE:
        o_data_in:
        {
            "table_urn": "urnXYZtableXYZmunicipioXYZarvores",
            "input_params": [
                {"name": "id", "value": "100000013"}, 
                {"name": "geometria", "value": "POINT(-9.43874639170304 38.73721155594517)"}, 
                {"name": "numero_registo", "value": "1001101"}, 
                {"name": "codigo_rua", "value": "20001101"}, 
                {"name": "rua", "value": "Rua de Teste 1101_c"}
                ],
        }
    */
    f_edit_obj_upsert: function(o_data_in, callback)
    {

        let url = xCore.application.endpoints.service_hub_base_url + '/rest/edit/call_method';

        let o_base_data = {
            "operation": "upsert"
        }

        //->(target, source)
        let o_data = ( o_data_in!=null )? Object.assign( o_data_in, o_base_data ): null;
        if(o_data==null)
        {
            throw 'error in "servercalls.f_edit_obj_upsert_post"';
        }


        return NSServerCalls.f_make_ajax_call_by_fetch(
            {
                "url": url,
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(o_data),
            }
            
            ).then(function(response)
        {
            let o_promise_resp_read = response.json();
            o_promise_resp_read.then( function(o_resp_json)
            {
                callback( o_resp_json );
            });

            
        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
        });
        
    },
    
    /**

    
        DELETE
        @param "o_data_in"
        @example
        "o_data_in":
        {
            "table_urn": "urnXYZtableXYZmunicipioXYZarvore",
            "id": "100000000"
        }

        @param callback:    function
        @example            function(o_res){...}
        @returns            null

        
        
    */
    f_edit_obj_delete: function(o_data_in, callback)
    {

        if(o_data_in.table_urn==null || o_data_in.id == null)
        {
            throw 'error in "servercalls.f_edit_obj_upsert"';
        }

        let url = xCore.application.endpoints.service_hub_base_url + '/rest/edit/call_method';

        let o_data = {
            "operation": "delete",
            "table_urn": o_data_in.table_urn,
            "input_params": [
                {"name": "id", "value": o_data_in.id}
                ]
        }

        NSServerCalls.f_make_ajax_call_by_fetch(
            {
                "url": url,
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(o_data),
            }
            
            ).then(function(response)
        {
            let o_promise_resp_read = response.json();
            o_promise_resp_read.then( function(o_resp_json)
            {
                callback( o_resp_json );
            });

            
        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
        });
        
    },

    /**
     * 
     * @param {*} f_callback  -> function (o_resp_json)
     */
    f_get_user_permissions: function(f_callback)
	{

        var url = xCore.application.endpoints.service_hub_base_url + '/rest/all/auth/get_user_function_collection_list';
        
        var o_in =
        {
            "url": url,
            method:'GET',
            headers: {
                'Content-Type': 'application/json',
            }
            
        };
        this.f_make_ajax_call_by_fetch(o_in).then(function(response)
        {
            let o_promise_resp_read = response.json();
            o_promise_resp_read.then( function(o_resp_json)
            {
                f_callback( o_resp_json );
            });

            
        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
        });
		
	},

    /**
        @param o_data_in
        @example
        o_data_in:
        {
            "table_urn": "urn__SEP__table__SEP__municipio__SEP__arvore",
            "condition_params": [
                {"column_internal_name": "id", "value": "10000", "operator": ">", "logical_operator": null}, 
                {"column_internal_name": "id", "value": "1000000000000", "operator": "<", "logical_operator": "and"}
                ],
            "geometry": {
                "column_internal_name": "geometria",
                "value": "{\"type\":\"Polygon\",\"coordinates\":[[[-1049177.4708982694, 4678065.734341598], [-1048030.9154739918, 4678065.734341598], [-1048030.9154739918, 4678545.854425515], [-1049177.4708982694, 4678545.854425515], [-1049177.4708982694, 4678065.734341598]]]}"
            },
            "limit": 21,
            "offset": 0
            
        }

        @returns promise object (handle_resolve(o_resp)) => o_resp is a json object
    */
    f_advanced_search: function(o_data_in)
    {

        let url = xCore.application.endpoints.service_hub_base_url + '/rest/read/advanced_search';

        let o_default_data = {
            //"language": "pt"
        }

        //->(target, source)
        let o_data = ( o_data_in!=null )? Object.assign( o_default_data, o_data_in ): o_default_data;


        let o_promise_ajax_call_result = NSServerCalls.f_make_ajax_call_by_fetch(
            {
                "url": url,
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(o_data),
            }
        );
          
        /*
        response:
        {
            "success": true,
            "total_count": 419,
            "column_internal_names" : [...],
            "rows" : [
                { "values": [...] }
                ...
            ],
        }
        */
        return o_promise_ajax_call_result.then(function(response)
        {
            let o_promise_resp_read_as_json = response.json();
            return o_promise_resp_read_as_json;
            
        })
        .then( function(o_promise_resp_read_as_json)
        {
            return o_promise_resp_read_as_json ;
        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
            
            throw new Error('Error - Something failed'); //throws error for calling method
        });

        
        
    },
    
    /**
        @param o_data_in
        @example
        o_data_in:
        {
            "s_record_urn": "urn__SEP__record__SEP__landbase__SEP__rua__SEP__1665872"
            
        }

        @returns promise object (handle_resolve(o_resp)) => o_resp is a json object
    */
    f_geospatial_context_search: function(o_data_in)
    {

        let url = xCore.application.endpoints.service_hub_base_url + '/rest/read/geospatial_context_search?s_record_urn='+o_data_in.s_record_urn;

        let o_default_data = {
            //"language": "pt"
        }

        //->(target, source)
        let o_data = ( o_data_in!=null )? Object.assign( o_default_data, o_data_in ): o_default_data;


        let o_promise_ajax_call_result = NSServerCalls.f_make_ajax_call_by_fetch(
            {
                "url": url,
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                }//,
                //body: JSON.stringify(o_data),
            }
        );
          
        /*
        response:
        {
            "success": true,
            "geometry_provider_table_urn": "urn__SEP__table__SEP__landbase__SEP__eixos_de_via"
            "geojson": {...}
        }
        */
        return o_promise_ajax_call_result.then(function(response)
        {
            let o_promise_resp_read_as_json = response.json();
            return o_promise_resp_read_as_json;
            
        })
        .then( function(o_promise_resp_read_as_json)
        {
            return o_promise_resp_read_as_json ;
        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
            
            throw new Error('Error - Something failed'); //throws error for calling method
        });

        
        
    },

    /**
        @param o_data_in
        @example
        o_data_in:
        {
            "search_text": "mato 42",
            "a_search_table":[
                {
                    "table_urn":"urn__SEP__table__SEP__landbase__SEP__numeros_policia",
                    "a_search_column_internal_name": ["rua_nome", "numero_de_policia"],
                    "result_id_column_internal_name": "id_rua"
                }

            ],
            "limit": 10,
            "offset": 0
        }
        @returns promise object (handle_resolve(o_resp)) => o_resp is a json object
    */
    f_text_search: function(o_data_in)
    {

        let url = xCore.application.endpoints.service_hub_base_url + '/rest/read/text_search';

        let o_default_data = {
            //"language": "pt"
        }

        //->(target, source)
        let o_data = ( o_data_in!=null )? Object.assign( o_default_data, o_data_in ): o_default_data;


        let o_promise_ajax_call_result = NSServerCalls.f_make_ajax_call_by_fetch(
            {
                "url": url,
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(o_data),
            }
        );
            
        /*
        response:
        {
            "a_row": [
                {
                    "description": "Rua do Mato Cordeiro 42",
                    "id": "1687684",
                    "search_table_urn": "urn__SEP__table__SEP__landbase__SEP__numeros_policia"
                },...
            ],
            "offset": 0,
            "success": true,
            "total_count": 3
        }
        */
        return o_promise_ajax_call_result.then(function(response)
        {
            let o_promise_resp_read_as_json = response.json();
            return o_promise_resp_read_as_json;
            
        })
        .then( function(o_promise_resp_read_as_json)
        {
            return o_promise_resp_read_as_json ;
        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
            
            throw new Error('Error - Something failed'); //throws error for calling method
        });
        
        
    },

    /** 
     * @returns promise object (handle_resolve(o_resp)) => o_resp is a json object
    */
    f_print_get_capabilities: function()
    {
        //http://127.0.0.1/servicehub/rest/read/mapfish/print/geocascais/capabilities.json
        let url = xCore.application.endpoints.service_hub_base_url + '/rest/read/mapfish/print/geocascais/capabilities.json';

        let o_default_data = {
            //"language": "pt"
        }



        let o_promise_ajax_call_result = NSServerCalls.f_make_ajax_call_by_fetch(
            {
                "url": url,
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );
            
        /*
        response:
       {
            "type": "FeatureCollection",
            "features": [
                {
                    "type": "Feature",
                    "id": "get_pdm_analysis.fid-1b80d505_181bbbd40d3_-7ffc",
                    "geometry": null,
                    "properties": {
                        "urn": "urn__SEP__field__SEP__municipio__SEP__ord_classificacao__SEP__37152786",
                        "pdm_info": "Solo Urbano",
                        "input_geom_area": 525.039442935119,
                        "intersection_area": 525.039442935119,
                        "geom_area": 56518748.5060999
                    }
                }, ...
            ],
            "totalFeatures": 8,
            "numberMatched": 8,
            "numberReturned": 8,
            "timeStamp": "2022-07-01T21:55:35.163Z",
            "crs": null
        }
        */
        return o_promise_ajax_call_result.then(function(response)
        {
            let o_promise_resp_read_as_json = response.json();
            return o_promise_resp_read_as_json;
            
        })
        .then( function(o_promise_resp_read_as_json)
        {
            return o_promise_resp_read_as_json ;
        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
            
            throw new Error('Error - Something failed'); //throws error for calling method
        });

    },

    /**
        @param o_data_in
        @example
        o_data_in:
        {
            "layout": "A4 portrait",
            "outputFilename": "nome_ficheiro",
            "attributes": {
                "mapTitle": "Título do Map Print 02",
                "scale_label_value": "1:2000",
                "map": {
                    "rotation": 0,
                    "center": [
                        -1048618.3509276763,
                        4678366.797897691
                    ],
                    "layers": [
                        {
                            "geoJson": {
                                "features": [
                                    {
                                        "geometry": {
                                            "coordinates": [
                                                -1048618.3509276763,
                                                4678366.797897691
                                            ],
                                            "type": "Point"
                                        },
                                        "type": "Feature",
                                        "properties": {
                                            "prop0": "value0 of point",
                                            "style_type": "point"
                                        }
                                    },
                                    {
                                        "geometry": {
                                            "coordinates": [
                                                [
                                                    -1048718.3509276763,
                                                    4678400
                                                ],
                                                [
                                                    -1048518,
                                                    4678166
                                                ]
                                            ],
                                            "type": "LineString"
                                        },
                                        "type": "Feature",
                                        "properties": {
                                            "prop0": "value0 of line",
                                            "style_type": "line"
                                        }
                                    },
                                    {
                                        "geometry": {
                                            "coordinates": [[
                                                [
                                                    -1048718.3509276763,
                                                    4678466
                                                ],
                                                [
                                                    -1048518,
                                                    4678466
                                                ],
                                                [
                                                    -1048518,
                                                    4678366.797897691
                                                ],
                                                [
                                                    -1048718.3509276763,
                                                    4678466
                                                ]
                                            ]],
                                            "type": "Polygon"
                                        },
                                        "type": "Feature",
                                        "properties": {
                                            "prop0": "value0 of polygon",
                                            "style_type": "polygon"
                                        }
                                    }
                                ],
                                "type": "FeatureCollection"
                            },
                            "style": {
                                "[style_type = 'point']": {"symbolizers": [{
                                    "fillColor": "green",
                                    "strokeWidth": 2,
                                    "strokeColor": "red",
                                    "type": "point",
                                    "pointRadius": 6,
                                    "strokeOpacity": 1
                                }]},
                                "[style_type = 'polygon']": {"symbolizers": [{
                                    "fillColor": "green",
                                    "strokeWidth": 2,
                                    "fillOpacity": 0.5,
                                    "strokeColor": "blue",
                                    "type": "polygon",
                                    "strokeOpacity": 1
                                }]},
                                "[style_type = 'line']": {"symbolizers": [{
                                    "strokeWidth": 4,
                                    "strokeColor": "#ffaaaa",
                                    "type": "line",
                                    "strokeOpacity": 1
                                }]},
                                "*": {"symbolizers": [{
                                    "haloOpacity": "0.7",
                                    "labelXOffset": "-1.0",
                                    "fillOpacity": 0,
                                    "labelYOffset": "-10.0",
                                    "haloRadius": "3.0",
                                    "haloColor": "#aaaaaa",
                                    "label": "[prop0]",
                                    "type": "text",
                                    "fontStyle": "normal",
                                    "fillColor": "#FF0000",
                                    "fontFamily": "sans-serif",
                                    "labelAlign": "cm",
                                    "fontSize": "12px",
                                    "labelRotation": "45",
                                    "fontColor": "#000000",
                                    "fontWeight": "bold"
                                }]},
                                "version": "2"
                            },
                            "type": "geojson"
                        },
                        {
                            "imageFormat": "image/png",
                            "baseURL": "http://localhost/geoserver/GeoCascais/wms",
                            "customParams": {"TRANSPARENT": "true"},
                            "layers": ["GeoCascais:arvore"],
                            "styles": [""],
                            "opacity": 1,
                            "type": "WMS"
                        },
                        {
                            "imageFormat": "image/png",
                            "baseURL": "http://localhost/geoserver/GeoCascais/wms",
                            "customParams": {"TRANSPARENT": "true"},
                            "layers": ["GeoCascais:cartografia_base_2019"],
                            "styles": [""],
                            "opacity": 1,
                            "type": "WMS"
                        }
                    ],
                    "scale": 2000,
                    "projection": "EPSG:3857",
                    "dpi": 72
                }
            },
            "title": "Título do Map Print"
        }
        @returns promise object (handle_resolve(o_resp)) => o_resp is a json object
    */
    f_print: function(o_data_in)
    {

        //http://127.0.0.1/servicehub/rest/read/mapfish/print/test_02_http/buildreport.pdf
        let url = xCore.application.endpoints.service_hub_base_url + '/rest/read/mapfish/print/geocascais/buildreport.pdf';

        let o_default_data = {
            "layout": "A4 portrait",
            "outputFilename": "nome_ficheiro",
            "attributes": {
                "mapTitle": "Título do Map Print 02",
                "scale_label_value": "1:2000",
                "map": {
                    "rotation": 0,
                    "center": [
                        -1048618.3509276763,
                        4678366.797897691
                    ],
                    "layers": [
                        {
                            "geoJson": {
                                "features": [
                                    {
                                        "geometry": {
                                            "coordinates": [
                                                -1048618.3509276763,
                                                4678366.797897691
                                            ],
                                            "type": "Point"
                                        },
                                        "type": "Feature",
                                        "properties": {
                                            "prop0": "value0 of point",
                                            "style_type": "point"
                                        }
                                    },
                                    {
                                        "geometry": {
                                            "coordinates": [
                                                [
                                                    -1048718.3509276763,
                                                    4678400
                                                ],
                                                [
                                                    -1048518,
                                                    4678166
                                                ]
                                            ],
                                            "type": "LineString"
                                        },
                                        "type": "Feature",
                                        "properties": {
                                            "prop0": "value0 of line",
                                            "style_type": "line"
                                        }
                                    },
                                    {
                                        "geometry": {
                                            "coordinates": [[
                                                [
                                                    -1048718.3509276763,
                                                    4678466
                                                ],
                                                [
                                                    -1048518,
                                                    4678466
                                                ],
                                                [
                                                    -1048518,
                                                    4678366.797897691
                                                ],
                                                [
                                                    -1048718.3509276763,
                                                    4678466
                                                ]
                                            ]],
                                            "type": "Polygon"
                                        },
                                        "type": "Feature",
                                        "properties": {
                                            "prop0": "value0 of polygon",
                                            "style_type": "polygon"
                                        }
                                    }
                                ],
                                "type": "FeatureCollection"
                            },
                            "style": {
                                "[style_type = 'point']": {"symbolizers": [{
                                    "fillColor": "green",
                                    "strokeWidth": 2,
                                    "strokeColor": "red",
                                    "type": "point",
                                    "pointRadius": 6,
                                    "strokeOpacity": 1
                                }]},
                                "[style_type = 'polygon']": {"symbolizers": [{
                                    "fillColor": "green",
                                    "strokeWidth": 2,
                                    "fillOpacity": 0.5,
                                    "strokeColor": "blue",
                                    "type": "polygon",
                                    "strokeOpacity": 1
                                }]},
                                "[style_type = 'line']": {"symbolizers": [{
                                    "strokeWidth": 4,
                                    "strokeColor": "#ffaaaa",
                                    "type": "line",
                                    "strokeOpacity": 1
                                }]},
                                "*": {"symbolizers": [{
                                    "haloOpacity": "0.7",
                                    "labelXOffset": "-1.0",
                                    "fillOpacity": 0,
                                    "labelYOffset": "-10.0",
                                    "haloRadius": "3.0",
                                    "haloColor": "#aaaaaa",
                                    "label": "[prop0]",
                                    "type": "text",
                                    "fontStyle": "normal",
                                    "fillColor": "#FF0000",
                                    "fontFamily": "sans-serif",
                                    "labelAlign": "cm",
                                    "fontSize": "12px",
                                    "labelRotation": "45",
                                    "fontColor": "#000000",
                                    "fontWeight": "bold"
                                }]},
                                "version": "2"
                            },
                            "type": "geojson"
                        },
                        {
                            "imageFormat": "image/png",
                            "baseURL": "http://localhost/geoserver/GeoCascais/wms",
                            "customParams": {"TRANSPARENT": "true"},
                            "layers": ["GeoCascais:arvore"],
                            "styles": [""],
                            "opacity": 1,
                            "type": "WMS"
                        },
                        {
                            "imageFormat": "image/png",
                            "baseURL": "http://localhost/geoserver/GeoCascais/wms",
                            "customParams": {"TRANSPARENT": "true"},
                            "layers": ["GeoCascais:cartografia_base_2024"],
                            "styles": [""],
                            "opacity": 1,
                            "type": "WMS"
                        }
                    ],
                    "scale": 2000,
                    "projection": "EPSG:3857",
                    "dpi": 72
                }
            },
            "title": "Título do Map Print"
        };

        o_default_data = {};
        
        //->(target, source)
        let o_data = ( o_data_in!=null )? Object.assign( o_default_data, o_data_in ): o_default_data;


        let o_promise_ajax_call_result = NSServerCalls.f_make_ajax_call_by_fetch(
            {
                "url": url,
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(o_data),
            }
        );
            
        /*
        response:
        {
            "a_row": [
                {
                    "description": "Rua do Mato Cordeiro 42",
                    "id": "1687684",
                    "search_table_urn": "urn__SEP__table__SEP__landbase__SEP__numeros_policia"
                },...
            ],
            "offset": 0,
            "success": true,
            "total_count": 3
        }
        *//*
        return o_promise_ajax_call_result.then(function(response)
        {
            let o_promise_resp_read_as_json = response.json();
            return o_promise_resp_read_as_json;
            
        })
        .then( function(o_promise_resp_read_as_json)
        {
            return o_promise_resp_read_as_json ;
        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
            
            throw new Error('Error - Something failed'); //throws error for calling method
        });
        */
        return o_promise_ajax_call_result
        .then( response => {
            
            let f_get_file_name = function(response)
            {
                let e_content_disposition = response.headers.get("content-disposition");
                if (e_content_disposition != null)
                {
                    let a_content_disposition = e_content_disposition.split(";");
                    
                    for(let i=0; i< a_content_disposition.length; i++)
                    {
                        //ex: 'attachment; filename=nome_ficheiro.pdf'
                        let s_elem_i = a_content_disposition[i];
                        let a_elem_i = s_elem_i.split("=");
                        if(a_elem_i.length > 1 && a_elem_i[0].trim() == "filename")
                        {
                            return a_elem_i[1];
                        }
                    }
                }

            }
            let s_file_name = f_get_file_name(response);

            //console.log("DEBUG AQUIIIII response:")
            //console.log(response)

            return response.blob()
        } )
        .then( blob => {


            /*
            //esta versão funciona, mas o o nome do ficheiro é apenas um número aleatório
            let file = window.URL.createObjectURL(blob);
            window.open(file, "_new_browsing_context_" + "s_guid_value");
            */

            /*
            let file = new File([blob], "filename.pdf"); 
            let s_url = window.URL.createObjectURL(file);
            console.log("s_url: "+s_url);
            
            let s_guid = NSFunctions.guidGenerator();
            window.open(s_url, "_new_browsing_context_" + "s_guid_value");
            */

            /*
            const FILE_NAME = "nome_ficheiro.pdf"

            let fileURL = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = fileURL;
            anchor.download = FILE_NAME;

            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            */

            
            //console.log("DEBUG AQUIIIII 2 blob:")
            //console.log(blob)

            return new Promise( (resolve, reject) => {
                resolve(blob);
            });

        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
            
            throw new Error('Error - Something failed'); //throws error for calling method
        });
        
        
    },
    
    
    /**
    @summary this print PDM service, will also generate and provide Mapfish the legend data and use the input map data to reproduce all the PDM needed maps
    @param o_data_in
        @summary similar to o_data_in of f_print, but for map object only use one "mapDef" property, this will be shared for all pdm maps
        @example
    @returns promise object (handle_resolve(o_resp)) => o_resp is a json object
    */
    f_print_pdm: function(o_data_in)
    {

        //http://127.0.0.1/servicehub/rest/read/print/print_pdm
        let url = xCore.application.endpoints.service_hub_base_url + '/rest/read/print/print_pdm';

        /* example
        let o_data_in = {
            "layout": "PDM template",
            "outputFilename": "nome_ficheiro",
            "attributes": {
                "mapTitle": "Título do Map Print 02",
                "map_scale_label_value": "1:2000",
                "mapDef": {
                    "rotation": 0,
                    "center": [
                        -1048618.3509276763,
                        4678366.797897691
                    ],
                    "layers": [{
                        "geoJson": {
                            "features": [{
                                "geometry": {
                                    "coordinates": [[
                                        [
                                            -1048683.6160358333,
                                            4678322.813565636
                                        ],
                                        [
                                            -1048705.7111143218,
                                            4678223.684294579
                                        ],
                                        [
                                            -1048659.1323002107,
                                            4678226.072951713
                                        ],
                                        [
                                            -1048683.6160358333,
                                            4678322.813565636
                                        ]
                                    ]],
                                    "type": "Polygon"
                                },
                                "type": "Feature",
                                "properties": {
                                    "style_type": "polygon",
                                    "prop_name_of_label_value": null
                                }
                            }],
                            "type": "FeatureCollection"
                        },
                        "style": {
                            "[style_type = 'point']": {"symbolizers": [{
                                "fillColor": "green",
                                "strokeWidth": 2,
                                "strokeColor": "red",
                                "type": "point",
                                "pointRadius": 6,
                                "strokeOpacity": 1
                            }]},
                            "[style_type = 'polygon']": {"symbolizers": [{
                                "fillColor": "green",
                                "strokeWidth": 2,
                                "fillOpacity": 0.5,
                                "strokeColor": "blue",
                                "type": "polygon",
                                "strokeOpacity": 1
                            }]},
                            "[style_type = 'line']": {"symbolizers": [{
                                "strokeWidth": 4,
                                "strokeColor": "#ffaaaa",
                                "type": "line",
                                "strokeOpacity": 1
                            }]},
                            "*": {"symbolizers": [{
                                "haloOpacity": "0.7",
                                "labelXOffset": "-1.0",
                                "fillOpacity": 0,
                                "labelYOffset": "-10.0",
                                "haloRadius": "3.0",
                                "haloColor": "#aaaaaa",
                                "label": "[prop_name_of_label_value]",
                                "type": "text",
                                "fontStyle": "normal",
                                "fillColor": "#FF0000",
                                "fontFamily": "sans-serif",
                                "labelAlign": "cm",
                                "fontSize": "12px",
                                "labelRotation": "45",
                                "fontColor": "#000000",
                                "fontWeight": "bold"
                            }]},
                            "version": "2"
                        },
                        "type": "geojson"
                    }],
                    "scale": 2500,
                    "projection": "EPSG:3857",
                    "dpi": 72
                },
                "b_print_ord_classificacao": true,
                "bb_min_y_etrs89_pt_tm06": "-500000",
                "bb_min_x_etrs89_pt_tm06": "-400000",
                "bb_max_x_etrs89_pt_tm06": "-100000",
                "bb_max_y_etrs89_pt_tm06": "-200000"
            }
        };
        */

        let o_default_data = {};
        
        //->(target, source)
        let o_data = ( o_data_in!=null )? Object.assign( o_default_data, o_data_in ): o_default_data;


        let o_promise_ajax_call_result = NSServerCalls.f_make_ajax_call_by_fetch(
            {
                "url": url,
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(o_data),
            }
        );
        
        /*
        return o_promise_ajax_call_result.then(function(response)
        {
            let o_promise_resp_read_as_json = response.json();
            return o_promise_resp_read_as_json;
            
        })
        .then( function(o_promise_resp_read_as_json)
        {
            return o_promise_resp_read_as_json ;
        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
            
            throw new Error('Error - Something failed'); //throws error for calling method
        });
        */
        return o_promise_ajax_call_result
        .then( response => {
            
            let f_get_file_name = function(response)
            {
                let e_content_disposition = response.headers.get("content-disposition");
                if (e_content_disposition != null)
                {
                    let a_content_disposition = e_content_disposition.split(";");
                    
                    for(let i=0; i< a_content_disposition.length; i++)
                    {
                        //ex: 'attachment; filename=nome_ficheiro.pdf'
                        let s_elem_i = a_content_disposition[i];
                        let a_elem_i = s_elem_i.split("=");
                        if(a_elem_i.length > 1 && a_elem_i[0].trim() == "filename")
                        {
                            return a_elem_i[1];
                        }
                    }
                }

            }
            let s_file_name = f_get_file_name(response);

            //console.log("DEBUG AQUIIIII response:")
            //console.log(response)

            return response.blob()
        } )
        .then( blob => {


            /*
            //esta versão funciona, mas o o nome do ficheiro é apenas um número aleatório
            let file = window.URL.createObjectURL(blob);
            window.open(file, "_new_browsing_context_" + "s_guid_value");
            */

            /*
            let file = new File([blob], "filename.pdf"); 
            let s_url = window.URL.createObjectURL(file);
            console.log("s_url: "+s_url);
            
            let s_guid = NSFunctions.guidGenerator();
            window.open(s_url, "_new_browsing_context_" + "s_guid_value");
            */

            /*
            const FILE_NAME = "nome_ficheiro.pdf"

            let fileURL = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = fileURL;
            anchor.download = FILE_NAME;

            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            */

            
            //console.log("DEBUG AQUIIIII 2 blob:")
            //console.log(blob)

            return new Promise( (resolve, reject) => {
                resolve(blob);
            });

        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
            
            throw new Error('Error - Something failed'); //throws error for calling method
        });
        
        
    },

    /**
        @param o_data_in
        @example:
       NSServerCalls.f_get_pdm_analysis(
                {"type":"Polygon","coordinates":[[[-1048745.7211213154,4678363.12215477],[-1048734.9721642127,4678283.699305068],[-1048628.0797574702,4678314.751847808],[-1048745.7211213154,4678363.12215477]]]}
            );

            NSServerCalls.f_get_pdm_analysis(
                NSToolDraw_.f_get_drawn_geometry_as_geo_json_feature().geometry
            );
        @returns promise object (handle_resolve(o_resp)) => o_resp is a json object
    */
    f_get_pdm_analysis: function(o_geo_json_geometry)
    {

        let url = xCore.application.endpoints.service_hub_base_url + '/rest/read/pdm/get_pdm_analysis';

        let o_default_data = {
            //"language": "pt"
        }

        //->(target, source)
        let o_data = ( o_geo_json_geometry!=null )? Object.assign( o_default_data, o_geo_json_geometry ): o_default_data;


        let o_promise_ajax_call_result = NSServerCalls.f_make_ajax_call_by_fetch(
            {
                "url": url,
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(o_data),
            }
        );
            
        /*
        response:
       {
            "type": "FeatureCollection",
            "features": [
                {
                    "type": "Feature",
                    "id": "get_pdm_analysis.fid-1b80d505_181bbbd40d3_-7ffc",
                    "geometry": null,
                    "properties": {
                        "urn": "urn__SEP__field__SEP__municipio__SEP__ord_classificacao__SEP__37152786",
                        "pdm_info": "Solo Urbano",
                        "input_geom_area": 525.039442935119,
                        "intersection_area": 525.039442935119,
                        "geom_area": 56518748.5060999
                    }
                }, ...
            ],
            "totalFeatures": 8,
            "numberMatched": 8,
            "numberReturned": 8,
            "timeStamp": "2022-07-01T21:55:35.163Z",
            "crs": null
        }
        */
        return o_promise_ajax_call_result.then(function(response)
        {
            let o_promise_resp_read_as_json = response.json();
            return o_promise_resp_read_as_json;
            
        })
        .then( function(o_promise_resp_read_as_json)
        {
            return o_promise_resp_read_as_json ;
        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
            
            throw new Error('Error - Something failed'); //throws error for calling method
        });
        
        
    },

    /**
        @param o_data_in
        @example:
       NSServerCalls.f_get_pdm_intersected_tables(
                {"type":"Polygon","coordinates":[[[-1048745.7211213154,4678363.12215477],[-1048734.9721642127,4678283.699305068],[-1048628.0797574702,4678314.751847808],[-1048745.7211213154,4678363.12215477]]]}
            );

            NSServerCalls.f_get_pdm_intersected_tables(
                NSToolDraw_.f_get_drawn_geometry_as_geo_json_feature().geometry
            );
        @returns promise object (handle_resolve(o_resp)) => o_resp is a json object
    */
    f_get_pdm_intersected_tables: function(o_geo_json_geometry)
    {

        let url = xCore.application.endpoints.service_hub_base_url + '/rest/read/print/get_pdm_intersected_tables';

        let o_default_data = {
            //"language": "pt"
        }

        //->(target, source)
        let o_data = ( o_geo_json_geometry!=null )? Object.assign( o_default_data, o_geo_json_geometry ): o_default_data;


        let o_promise_ajax_call_result = NSServerCalls.f_make_ajax_call_by_fetch(
            {
                "url": url,
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(o_data),
            }
        );
            
        /*
        response:
       {
            "type": "FeatureCollection",
            "features": [
                {
                    "type": "Feature",
                    "id": "get_pdm_intersected_tables.fid-1b80d505_181bbbd40d3_-7fde",
                    "geometry": null,
                    "properties": {
                        "b_intersects": true,
                        "table_name": "ord_classificacao"
                    }
                }, ...
            ],
            "totalFeatures": 8,
            "numberMatched": 8,
            "numberReturned": 8,
            "timeStamp": "2022-07-01T21:55:35.163Z",
            "crs": null
        }
        */
        return o_promise_ajax_call_result.then(function(response)
        {
            let o_promise_resp_read_as_json = response.json();
            return o_promise_resp_read_as_json;
            
        })
        .then( function(o_promise_resp_read_as_json)
        {
            return o_promise_resp_read_as_json ;
        })
        .catch(err => { 
            console.log(err);
            console.log( "error" + err.status + err.statusText );
            
            throw new Error('Error - Something failed'); //throws error for calling method
        });
        
        
    },

    geoserver: {
        wmts : {
            get_feature: function(tileParam, s_table_name_list, callback) 
            {

                /*
                
                http://10.129.90.41/servicehub/geoserver/ogc/gwc/service/wmts?VERSION=1.0.0&LAYER=GeoCascais:carta_declives&STYLE=&TILEMATRIX=EPSG:900913:13&TILEMATRIXSET=EPSG:900913&SERVICE=WMTS&FORMAT=image/png&SERVICE=WMTS&REQUEST=GetFeatureInfo&INFOFORMAT=application/json&TileCol=3882&TileRow=3139&I=35&J=61

                */

                let url = xCore.application.endpoints.service_hub_base_url + `/geoserver/ogc/gwc/service/wmts?VERSION=1.0.0?VERSION=1.0.0&LAYER=GeoCascais:${s_table_name_list}&STYLE=&TILEMATRIX=EPSG:900913:${tileParam.tileCoord[0]}&TILEMATRIXSET=EPSG:900913&SERVICE=WMTS&FORMAT=image/png&SERVICE=WMTS&REQUEST=GetFeatureInfo&INFOFORMAT=application/json&TileCol=${tileParam.tileCoord[1]}&TileRow=${tileParam.tileCoord[2]}&I=${tileParam.tilePixel[0]}&J=${tileParam.tilePixel[1]}`;

                NSServerCalls.f_make_ajax_call_by_fetch({"url": url}).then(function(response)
                {
                    let o_promise_resp_read = response.json();
                    o_promise_resp_read.then( function(o_resp_json)
                    {
                        //ns_geoserver[s_table_urn] = o_resp_json;
                        callback( o_resp_json );
                    });
    
                    
                })
                .catch(err => { 
                    console.log(err);
                    console.log( "error" + err.status + err.statusText );
                });
            }

        },
        wfs : {
    
            /**
                @param {String} s_table_name_list               ->comma separated ex: "arvore,estrutura_verde"
                @param
                s_id_list 						-> ex: "1,3,7"
                @param
                s_cache_limitation_param_value	-> optional, this value will be added to url which allow to control cache
            */
            get_feature_by_id_list : function( s_table_name_list, s_id_list , params, callback, s_cache_limitation_param)
            {
                this.get_feature( s_table_name_list, null, null, s_id_list , params, callback, s_cache_limitation_param);
                
            },
            /**
                @param {String} s_table_name_list               ->comma separated ex: "arvore,estrutura_verde"
                @param {array}  a_bounding_box
                @param {String} s_id_list                       -> ex: "1,3,7"
                @param {String} s_cache_limitation_param_value  -> optional, this value will be added to url which allow to control cache
                @param {String} s_property_name_list            -> If s_table_name_list has one element, comma separeted property names to be returned by the service ex: "geom, local".
                                                                -> If s_table_name_list has multiple elements format changes, ex (for two tables): "(rua)(gestor,area_m2)"
                                                
            */
            get_feature : function( s_table_name_list, max_features, a_bounding_box, s_id_list , params, callback, s_cache_limitation_param_value, s_property_name_list, s_cql_filter )
            {
                this.get_feature_2( s_table_name_list, max_features, a_bounding_box, s_id_list , params, callback, s_cache_limitation_param_value, null, s_property_name_list, s_cql_filter);
            },

            /**
                @summary can by used passing a bounding box (a_bounding_box) or an id list (s_id_list)
                @returns {string} url
                @param {string} s_table_name 
                @param {int} max_features
                @param {array} a_bounding_box
                @param {string} s_id_list 						-> ex: "1,3,7"
                @param {string} s_cache_limitation_param_value	-> optional, this value will be added to url which allow to control cache
            */
            get_export_shape_format_url : function( s_table_name, max_features, a_bounding_box, s_id_list, s_cache_limitation_param_value)
            {
                let s_output_format = "SHAPE-ZIP";
                return this.get_export_url( s_table_name, max_features, a_bounding_box, s_id_list, s_cache_limitation_param_value, s_output_format); 
            },
            /**
                @summary can by used passing a bounding box (a_bounding_box) or an id list (s_id_list)
                @returns {string} url
                @param {string} s_table_name 
                @param {int} max_features
                @param {array} a_bounding_box
                @param {string} s_id_list 						-> ex: "1,3,7"
                @param {string} s_cache_limitation_param_value	-> optional, this value will be added to url which allow to control cache
            */
            get_export_shape_dxf_url : function( s_table_name, max_features, a_bounding_box, s_id_list, s_cache_limitation_param_value)
            {
                let s_output_format = "dxf";
                return this.get_export_url( s_table_name, max_features, a_bounding_box, s_id_list, s_cache_limitation_param_value, s_output_format); 
            },
            /**
                @summary can by used passing a bounding box (a_bounding_box) or an id list (s_id_list)
                @returns {string} url
                @param {string} s_table_name 
                @param {int} max_features
                @param {array} a_bounding_box
                @param {string} s_id_list 						-> ex: "1,3,7"
                @param {string} s_cache_limitation_param_value	-> optional, this value will be added to url which allow to control cache
            */
            get_export_shape_csv_url : function( s_table_name, max_features, a_bounding_box, s_id_list, s_cache_limitation_param_value)
            {
                let s_output_format = "csv";
                return this.get_export_url( s_table_name, max_features, a_bounding_box, s_id_list, s_cache_limitation_param_value, s_output_format); 
            },

            /**
                @summary can by used passing a bounding box (a_bounding_box) or an id list (s_id_list)
                @returns {string} url
                @param {string} s_table_name 
                @param {int} max_features
                @param {array} a_bounding_box
                @param {string} s_id_list 						-> ex: "1,3,7"
                @param {string} s_cache_limitation_param_value	-> optional, this value will be added to url which allow to control cache
                @param {string} s_output_format                 -> ex: "SHAPE-ZIP" || "dxf"  || "csv" 
                @param {string} s_column_internal_name_list     -> ex: "col_a,col_b,col_c"
            */

            f_b_export_format_needs_geometry: function(s_output_format)
            {
                //let b_output_format_has_geometry = (s_output_format.toLocaleLowerCase() == "shape-zip" || s_output_format.toLocaleLowerCase() == "dxf" )
                let a_export_format_needs_geometry_lc = ["shape-zip", "dxf"];
                let b_export_format_needs_geometry = ( a_export_format_needs_geometry_lc.indexOf( s_output_format.toLocaleLowerCase() ) > -1 ) ? true : false;
                return b_export_format_needs_geometry;
            },

            get_export_url : function( s_table_name, max_features, a_bounding_box, s_id_list, s_cache_limitation_param_value, s_output_format, s_column_internal_name_list)
            {
                let s_CONST_GEOSERVER_WORKSPACE = NSServerCalls_Private.private_objs.s_CONST_GEOSERVER_WORKSPACE;
                
                if( !max_features || max_features == null )
                    max_features = 50;//NSConfig.geoserver.max_features;
    
                //let url = NSConfig.geoserver.url + "/" + store  + NSConfig.geoserver.services.wfs.base + NSConfig.geoserver.services.wfs.get_feature + "&maxFeatures=" + max_features + "&typeName=" + store + ":" + layer;
                //let url = '../../servicehub/geoserver/ogc/GeoCascais/ows?service=WFS&version=1.0.0&request=GetFeature&outputFormat=application/json';
                let url = xCore.application.endpoints.service_hub_base_url + '/geoserver/ogc/'+s_CONST_GEOSERVER_WORKSPACE+'/ows?service=WFS&version=1.0.0&request=GetFeature';
    
                if(s_cache_limitation_param_value != null && s_cache_limitation_param_value != "")
                {
                    let s_cache_limitation_param = "&cache_limitation_param="+s_cache_limitation_param_value;
                    url += s_cache_limitation_param;
                }
                
                let s_typeName = "&typeName=" + s_CONST_GEOSERVER_WORKSPACE+':'+s_table_name;
                let s_max_fetures = "&maxFeatures=" + max_features;
                url += s_typeName + s_max_fetures;
    
                if(a_bounding_box != null && a_bounding_box.length==4)
                {
                    url += "&bbox=" + a_bounding_box.join(',');
                }

                if(s_output_format != null && s_output_format.length>0)
                {
                    url += "&outputFormat=" + s_output_format;

                    if(s_output_format.toLowerCase() == "csv")
                    {
                        url += '&format_options=csvseparator:semicolon';
                        url += '&add_bom_to_wfs_csv_export_utf8_output=true';
                    }
                }
    
                if(s_id_list != null && s_id_list != "")
                {
                    url += "&featureId=" + s_id_list;
                }

                if(s_column_internal_name_list != null && s_column_internal_name_list != "")
                {
                    url += "&propertyName=" + s_column_internal_name_list;
                }

                let b_output_format_has_geometry = this.f_b_export_format_needs_geometry(s_output_format);
                if(b_output_format_has_geometry)
                {
                    url += "&srsName=EPSG:3763"; // to convert output geometries to desired CRS
                }
                
                return url;

            },

            /**
             * @description Using "cql_filter", unlike standard WFS "bbox" parameter, the geometrical filter wont simplify all geometries to bboxes for performance reasons
             */
            get_export_url_bbox_using_cql_filter : function( s_table_name, max_features, a_bounding_box, s_id_list, s_cache_limitation_param_value, s_output_format, s_column_internal_name_list)
            {
                let s_CONST_GEOSERVER_WORKSPACE = NSServerCalls_Private.private_objs.s_CONST_GEOSERVER_WORKSPACE;
                
                if( !max_features || max_features == null )
                    max_features = 50;//NSConfig.geoserver.max_features;
    
                //let url = NSConfig.geoserver.url + "/" + store  + NSConfig.geoserver.services.wfs.base + NSConfig.geoserver.services.wfs.get_feature + "&maxFeatures=" + max_features + "&typeName=" + store + ":" + layer;
                //let url = '../../servicehub/geoserver/ogc/GeoCascais/ows?service=WFS&version=1.0.0&request=GetFeature&outputFormat=application/json';
                let url = xCore.application.endpoints.service_hub_base_url + '/geoserver/ogc/'+s_CONST_GEOSERVER_WORKSPACE+'/ows?service=WFS&version=1.0.0&request=GetFeature';
    
                if(s_cache_limitation_param_value != null && s_cache_limitation_param_value != "")
                {
                    let s_cache_limitation_param = "&cache_limitation_param="+s_cache_limitation_param_value;
                    url += s_cache_limitation_param;
                }
                
                let s_typeName = "&typeName=" + s_CONST_GEOSERVER_WORKSPACE+':'+s_table_name;
                let s_max_fetures = "&maxFeatures=" + max_features;
                url += s_typeName + s_max_fetures;
    
                if(a_bounding_box != null && a_bounding_box.length==4)
                {
                    //url += "&bbox=" + a_bounding_box.join(',');

                    let a_polygon_coordinates = [
                            [a_bounding_box[0], a_bounding_box[1]],
                            [a_bounding_box[0], a_bounding_box[3]],
                            [a_bounding_box[2], a_bounding_box[3]],
                            [a_bounding_box[2], a_bounding_box[1]],
                            [a_bounding_box[0], a_bounding_box[1]],
                        ];
                    const a_polygon_coordinates_filter = a_polygon_coordinates.map((el) => el.join(' '));
                    const s_polygon_coordinates_filter = a_polygon_coordinates_filter.toString();
                    let s_geometry_property_name = "geom";
                    const s_cql_filter = `INTERSECTS(${s_geometry_property_name},POLYGON((${s_polygon_coordinates_filter})))`;
                    url += "&cql_filter=" + s_cql_filter;

                }

                if(s_output_format != null && s_output_format.length>0)
                {
                    url += "&outputFormat=" + s_output_format;
                }
    
                if(s_id_list != null && s_id_list != "")
                {
                    url += "&featureId=" + s_id_list;
                }

                if(s_column_internal_name_list != null && s_column_internal_name_list != "")
                {
                    url += "&propertyName=" + s_column_internal_name_list;
                }

                let b_output_format_has_geometry = this.f_b_export_format_needs_geometry(s_output_format);
                if(b_output_format_has_geometry)
                {
                    url += "&srsName=EPSG:3763"; // to convert output geometries to desired CRS
                }
                
                return url;

            },

            /**
                @param {array} a_bounding_box
                @param
                s_id_list 						-> ex: "1,3,7"
                @param
                s_cache_limitation_param_value	-> optional, this value will be added to url which allow to control cache
                @param
                s_output_format                 -> ex: "SHAPE-ZIP" || "dxf"  || "csv" 


                
                @param {String} s_table_name_list               ->comma separated ex: "arvore,estrutura_verde"
                @param {array}  a_bounding_box
                @param {String} s_id_list                       -> ex: "1,3,7"
                @param {String} s_cache_limitation_param_value  -> optional, this value will be added to url which allow to control cache
                @param {String} s_property_name_list            -> If s_table_name_list has one element, comma separeted property names to be returned by the service ex: "geom, local".
                                                                -> If s_table_name_list has multiple elements format changes, ex (for two tables): "(rua)(gestor,area_m2)"
                 
            */
            get_feature_2 : function( s_table_name_list, max_features, a_bounding_box, s_id_list , params, callback, s_cache_limitation_param_value, s_output_format, s_property_name_list, s_cql_filter)
            {
                let s_CONST_GEOSERVER_WORKSPACE = NSServerCalls_Private.private_objs.s_CONST_GEOSERVER_WORKSPACE;
    
                if( !max_features || max_features == null )
                    max_features = 50;//NSConfig.geoserver.max_features;
    
                //let url = NSConfig.geoserver.url + "/" + store  + NSConfig.geoserver.services.wfs.base + NSConfig.geoserver.services.wfs.get_feature + "&maxFeatures=" + max_features + "&typeName=" + store + ":" + layer;
                //let url = '../../servicehub/geoserver/ogc/GeoCascais/ows?service=WFS&version=1.0.0&request=GetFeature&outputFormat=application/json';
                let url = xCore.application.endpoints.service_hub_base_url + '/geoserver/ogc/'+s_CONST_GEOSERVER_WORKSPACE+'/ows?service=WFS&version=1.0.0&request=GetFeature&outputFormat=application/json';
    
                if(s_cache_limitation_param_value != null && s_cache_limitation_param_value != "")
                {
                    let s_cache_limitation_param = "&cache_limitation_param="+s_cache_limitation_param_value;
                    url += s_cache_limitation_param;
                }
                
                //let s_typeName = "&typeName=" + 'GeoCascais:arvores';
                let s_typeName = "";

                let a_table_name_list = s_table_name_list.split(",");
                a_table_name_list.forEach((s_table_name)=>
                {
                    s_typeName += "," + s_CONST_GEOSERVER_WORKSPACE+':'+s_table_name;
                });
                s_typeName = s_typeName.substring(1); // removing first comma
                s_typeName = "&typeName=" + s_typeName;

                let s_max_fetures = "&maxFeatures=" + max_features;
                
                url += s_typeName + s_max_fetures;
    
                if(a_bounding_box != null && a_bounding_box.length==4)
                {
                    url += "&bbox=" + a_bounding_box.join(',');
                }

                if(s_output_format != null && s_output_format.length>0)
                {
                    url += "&outputFormat=" + s_output_format;
                }
    
                if(s_id_list != null && s_id_list != "")
                {
                    url += "&featureId=" + s_id_list;
                }

                if(s_property_name_list != null && s_property_name_list != "")
                {
                    url += "&propertyName=" + s_property_name_list;
                }
                
                if( params != null && Object.entries(params).length > 0 ){
                    url += "&viewparams="
                    for (let key in params)
                        if (params.hasOwnProperty(key)) { url += key + ":" + params[key] + ";"}
                    url = url.substring( 0 , url.length - 1 );
                }

                if(s_cql_filter != null && s_cql_filter != "")
                {
                    url += "&cql_filter=" + s_cql_filter;
                }
                
                //url += "&outputFormat=application%2Fjson";
    
                NSServerCalls.f_make_ajax_call_by_fetch({"url": url}).then(function(response)
                {
                    let o_promise_resp_read = response.json();
                    o_promise_resp_read.then( function(o_resp_json)
                    {
                        //ns_geoserver[s_table_urn] = o_resp_json;
                        callback( o_resp_json );
                    });
    
                    
                })
                .catch(err => { 
                    console.log(err);
                    console.log( "error" + err.status + err.statusText );
                });
            },


            /**
            @example:
            NSServerCalls_.geoserver.wfs.f_get_pdm_analysis(
                {"type":"Polygon","coordinates":[[[-1048745.7211213154,4678363.12215477],[-1048734.9721642127,4678283.699305068],[-1048628.0797574702,4678314.751847808],[-1048745.7211213154,4678363.12215477]]]},
                (o_resp)=>{console.log(o_resp);},
                null
            );

            NSServerCalls_.geoserver.wfs.f_get_pdm_analysis(
                NSToolDraw_.f_get_drawn_geometry_as_geo_json_feature().geometry,
                (o_resp)=>{console.log(o_resp);},
                null
            );
            */
            f_get_pdm_analysis: function(o_geo_json_geometry, callback, s_cache_limitation_param_value)
            {

                /*
                encodeURIComponent('{"type":"Polygon"\\,"coordinates":[[[-1048745.7211213154\\,4678363.12215477]\\,[-1048734.9721642127\\,4678283.699305068]\\,[-1048628.0797574702\\,4678314.751847808]\\,[-1048745.7211213154\\,4678363.12215477]]]}')
                '%7B%22type%22%3A%22Polygon%22%5C%2C%22coordinates%22%3A%5B%5B%5B-1048745.7211213154%5C%2C4678363.12215477%5D%5C%2C%5B-1048734.9721642127%5C%2C4678283.699305068%5D%5C%2C%5B-1048628.0797574702%5C%2C4678314.751847808%5D%5C%2C%5B-1048745.7211213154%5C%2C4678363.12215477%5D%5D%5D%7D'
                */
                let s_geo_json_geometry = JSON.stringify(o_geo_json_geometry);
                //console.log("ANTES  - s_geo_json_geometry="+s_geo_json_geometry)
                s_geo_json_geometry = s_geo_json_geometry.split(",").join("\\,");
                //console.log("DEPOIS - s_geo_json_geometry="+s_geo_json_geometry)
                s_geo_json_geometry = encodeURIComponent(s_geo_json_geometry);

                this.get_feature("get_pdm_analysis", 500, null, null, {"s_geojson": s_geo_json_geometry}, callback, s_cache_limitation_param_value)

            }
        }
    }




};




NSServerCalls.init();